import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";

import zh from "vee-validate/dist/locale/zh_CN"; // 引入中文文件

Validator.addLocale(zh); // 使用中文
const config = {
  locale: "zh_CN",
  fieldsBagName: "vee-fields",
  // events: 'Passive',
};

Vue.use(VeeValidate, config);

// 自定义validate
const dict = {
  custom: {
    store_name: {
      required: "请输入商户名称",
    },
    short_name: {
      required: "请输入商户简称",
    },
    contact_name: {
      required: "请输入商户联系人姓名",
    },
    mobile_phone: {
      required: "请输入商户联系人电话",
    },
    id_card_name: {
      required: "请输入姓名",
    },
    id_card_number: {
      required: "请输入身份证号",
    },
    file: {
      required: "请上传图片",
    },
    id_card_valid_time_begin: {
      required: "请选择身份证有效期开始时间",
    },
    id_card_valid_time: {
      required: "请选择身份证有效期结束时间",
    },
  },
};

Validator.localize("zh_CN", dict);

// 自定义验证规则
Validator.extend("mobile", {
  getMessage: (field) => "请输入正确的手机号码",
  validate: (value) => {
    return /^1[34578]\d{9}$/.test(value);
  },
});

// 身份证验证
Validator.extend("id_card", {
  getMessage: (field) => "请输入正确的身份证号码",
  validate: (value) => {
    return /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/.test(
      value
    );
  },
});

// 图片
Validator.extend("image", {
  getMessage: (field) => "请上传图片",
  validate: (value) => {
    return value != "";
  },
});
